import { type OperationResponse } from "../../../../common.ts";
import {
  omitPathParameters,
  replacePathParameters,
} from "../../../../utils.ts";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./index.ts";

export const getResourceOperations = (client: AxiosInstance) => {
  const copyLocale = (
    parameters: Paths.CopyLocale.QueryParameters &
      Paths.CopyLocale.PathParameters,
    data?: Paths.CopyLocale.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.CopyLocale.Responses.$200> => {
    const url = "/system/resource/copy-locale";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    copyLocale,
  };
};
